"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Typography = void 0;
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const react_1 = __importDefault(require("react"));
const weightMap = {
    light: 300,
    regular: 400,
    medium: 600,
    bold: 700,
};
const TypographyComponent = (props, ref) => {
    const { weight = 'regular', sx, status, ...rest } = props;
    return (react_1.default.createElement(Typography_1.default, { ref: ref, sx: {
            fontWeight: weightMap[weight],
            ...sx,
        }, color: status ? '#3B61A2' : undefined, ...rest }));
};
exports.Typography = react_1.default.forwardRef(TypographyComponent);
exports.default = exports.Typography;
